module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome"
  }, [_c('pre-load-image'), _vm._v(" "), _c('gene-background'), _vm._v(" "), _c('div', {
    staticClass: "welcome__inner"
  }, [_c('vue-audio', {
    ref: "btnClick",
    attrs: {
      "file": 3,
      "redirect": _vm.redirect
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "welcome__list"
  }, [_c('li', {
    staticClass: "welcome__item welcome__title"
  }, [_vm._v("Smartcell Horseracing スマートセル　ホースレーシング")]), _vm._v(" "), _c('li', {
    staticClass: "welcome__item welcome__detail"
  }, [_c('p', {
    staticClass: "welcome__quote"
  }, [_vm._v("ゲノムカードで最速のユニコーンをよびだそう！")]), _vm._v(" "), _c('button', {
    staticClass: "welcome__button",
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.start
    }
  }, [_c('span')]), _vm._v(" "), _c('button', {
    staticClass: "welcome__how-to",
    on: {
      "click": _vm.showModal
    }
  }, [_c('span')])]), _vm._v(" "), _c('li', {
    staticClass: "welcome__item welcome__image"
  }, [_vm._v("Smartcell Horseracing スマートセル　ホースレーシング")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "id": _vm.key,
      "show": _vm.isModal,
      "type": _vm.typeName
    },
    on: {
      "update:show": function($event) {
        _vm.isModal = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efed13cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 88
// module chunks = 0